<header class="header-2" style="min-height: 4rem">
  <div class="branding">
    <span class="title">{{ 'Werksabnahme - neues Objekt erstellen' | mrTranslate | titlecase }}</span>
  </div>
  <div class="header-actions" style="min-height: 4rem">
    <form
      id="fatobjekterstellendialog-gruppe-form"
      style="padding: 0px; padding-right: 1.5rem"
      (ngSubmit)="sendForFormulare()">
      <div class="clr-row">
        <!-- Interne Gruppe (only shown for Admin) -->
        @if (showInternalDropdown) {
          <div class="clr-col-6">
            <div class="clr-form-control" style="margin-top: 0.3rem">
              <label for="internegruppeid" class="clr-control-label" style="color: #fafafa">
                {{ internalDropdownTitle | mrTranslate }}
              </label>
              <div
                class="clr-control-container"
                [ngClass]="{ 'clr-error': kunde.length > 0 && !gruppeinternegruppeid }">
                <div class="clr-select-wrapper">
                  <select
                    id="internegruppeid"
                    class="clr-select"
                    name="gruppeinternegruppeid"
                    [disabled]="!gruppeEnabled"
                    [(ngModel)]="gruppeinternegruppeid"
                    required
                    style="color: #fafafa; min-width: 10rem"
                    data-test-id="werksabnahme-internal-group">
                    @for (val of internerkunde; track val) {
                      <option [value]="val.ID">
                        {{ val.Bezeichnung | oktaGroupName }}
                      </option>
                    }
                  </select>
                  @if (kunde.length > 0 && !gruppeinternegruppeid) {
                    <cds-icon class="clr-validate-icon" shape="exclamation-circle" />
                  }
                </div>
                @if (kunde.length > 0 && !gruppeinternegruppeid) {
                  <span class="clr-subtext">
                    {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                  </span>
                }
                @if (kunde.length === 0) {
                  <span class="clr-subtext">{{ 'Interne Gruppe Setup Dropdown' | mrTranslate }}</span>
                }
              </div>
            </div>
          </div>
        }

        <!-- Kunden Gruppe (always shown) -->
        <div class="clr-col-6">
          <div class="clr-form-control" style="margin-top: 0.3rem">
            <label for="gruppeid" class="clr-control-label" style="color: #fafafa">
              {{ customerDropdownTitle | mrTranslate }}
            </label>
            <div class="clr-control-container" [ngClass]="{ 'clr-error': kunde.length > 0 && !gruppegruppeid }">
              <div class="clr-select-wrapper">
                <select
                  id="gruppeid"
                  class="clr-select"
                  name="gruppegruppeid"
                  [(ngModel)]="gruppegruppeid"
                  required
                  [disabled]="!gruppeEnabled || kunde.length === 0"
                  style="color: #fafafa; min-width: 10rem"
                  data-test-id="werksabnahme-customer-group">
                  @if (adminGroups.length) {
                    <optgroup label="{{ 'Admin Gruppen' | mrTranslate }}">
                      @for (val of adminGroups; track val) {
                        <option [value]="val.ID">
                          {{ val.Bezeichnung | oktaGroupName }}
                        </option>
                      }
                    </optgroup>
                  }
                  @if (internalGroups.length) {
                    <optgroup label="{{ 'Interne Gruppen' | mrTranslate }}">
                      @for (val of internalGroups; track val) {
                        <option [value]="val.ID">
                          {{ val.Bezeichnung | oktaGroupName }}
                        </option>
                      }
                    </optgroup>
                  }
                  @if (externalGroups.length) {
                    <optgroup label="{{ 'Kunden Gruppen' | mrTranslate }}">
                      @for (val of externalGroups; track val) {
                        <option [value]="val.ID">
                          {{ val.Bezeichnung | oktaGroupName }}
                        </option>
                      }
                    </optgroup>
                  }
                </select>
                @if (kunde.length > 0 && !gruppegruppeid) {
                  <cds-icon class="clr-validate-icon" shape="exclamation-circle" />
                }
              </div>
              @if (kunde.length > 0 && !gruppegruppeid) {
                <span class="clr-subtext">
                  {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                </span>
              }
              @if (kunde.length === 0) {
                <span class="clr-subtext">{{ 'Kunden Gruppe Setup Dropdown' | mrTranslate }}</span>
              }
            </div>
          </div>
        </div>
      </div>
    </form>

    @if (editable && gruppeEnabled && canCreateGroups) {
      <a
        href="javascript://"
        class="nav-link nav-icon"
        data-test-id="werksabnahme-create-group"
        [title]="tooltips.createGroup">
        <cds-icon shape="plus-circle" (click)="createGroup()" />
      </a>
    }
    <a href="javascript://" class="nav-link nav-icon" data-test-id="werksabnahme-save" [title]="tooltips.save">
      <cds-icon shape="floppy" (click)="sendForFormulare()" />
    </a>
    <a href="javascript://" class="nav-link nav-icon" data-test-id="werksabnahme-close" [title]="tooltips.cancel">
      <cds-icon shape="times" (click)="close()" />
    </a>
  </div>
</header>

<div class="overlay-inner-wrapper">
  <div id="datenTabs">
    <clr-tabs>
      <!-- 1. TAB: FICHE DE CONTRÔLE -->
      <clr-tab>
        <button
          clrTabLink
          (click)="tabChange()"
          [title]="'Formularerstellung' | mrTranslate"
          data-test-id="fat-objekt-tab-weiche">
          {{ 'Weiche' | mrTranslate | titlecase }}
        </button>
        <clr-tab-content *clrIfActive>
          <div id="formularerstellungsWrapper" class="fat-scroll-container">
            <div class="clr-row">
              <div class="clr-col-3"></div>
              <div class="clr-col-12 clr-col-lg-6">
                @if (formReflectData.length > 0) {
                  <form clrForm class="clr-form clr-form-horizontal">
                    @for (reflectData of formReflectData; track reflectData) {
                      @if (reflectData.mainTitle) {
                        <h1 id="mainTitle">{{ reflectData.mainTitle }}</h1>
                      }
                      @if (reflectData.title) {
                        <h4 id="title">{{ reflectData.title }}</h4>
                      }
                      @if (reflectData.subheading) {
                        @if (reflectData.fieldType === 'text') {
                          <div class="objektTyp1">
                            <div class="comboboxcontainer clr-form-control clr-row">
                              @if (reflectData.subheading) {
                                <label class="clr-col-md-4 clr-control-label" id="subheading">
                                  {{ reflectData.subheading }}
                                </label>
                              }
                              <div class="clr-control-container clr-col-md-8">
                                <input
                                  clrInput
                                  style="width: 300px"
                                  type="text"
                                  [(ngModel)]="reflectData.value"
                                  [ngModelOptions]="{ standalone: true }"
                                  data-test-id="fat-objekt-text-input" />
                              </div>
                            </div>
                          </div>
                        }
                        @if (reflectData.fieldType === 'dropdown') {
                          <div class="objektTyp2">
                            <div class="comboboxcontainer clr-form-control clr-row">
                              @if (reflectData.subheading) {
                                <label class="clr-col-md-4 clr-control-label" id="subheading">
                                  {{ reflectData.subheading }}
                                </label>
                              }
                              <div class="clr-control-container clr-col-md-8">
                                <input
                                  clrInput
                                  style="width: 300px"
                                  type="number"
                                  min="0"
                                  [(ngModel)]="reflectData.value"
                                  [ngModelOptions]="{ standalone: true }"
                                  data-test-id="fat-objekt-number-input" />
                              </div>
                            </div>
                          </div>
                        }
                        @if (reflectData.fieldType === 'date') {
                          <div class="objektTyp3">
                            <div class="comboboxcontainer clr-form-control clr-row">
                              @if (reflectData.subheading) {
                                <label class="clr-col-md-4 clr-control-label" id="subheading">
                                  {{ reflectData.subheading }}
                                </label>
                              }
                              <div class="clr-control-container clr-col-md-8">
                                <input
                                  clrInput
                                  style="width: 300px"
                                  type="date"
                                  [(ngModel)]="reflectData.value"
                                  [ngModelOptions]="{ standalone: true }"
                                  data-test-id="fat-objekt-date-input" />
                              </div>
                            </div>
                          </div>
                        }
                        @if (reflectData.fieldType === 'checkbox') {
                          <div class="objektTypCheckbox">
                            <div class="comboboxcontainer clr-form-control clr-row">
                              @if (reflectData.subheading) {
                                <label class="clr-col-md-4 clr-control-label" id="subheading">
                                  {{ reflectData.subheading }}
                                </label>
                              }
                              <div class="clr-control-container clr-col-md-8">
                                <clr-checkbox-container>
                                  <clr-checkbox-wrapper>
                                    <input
                                      type="checkbox"
                                      clrCheckbox
                                      [(ngModel)]="reflectData.value"
                                      class="cb"
                                      data-test-id="fat-objekt-checkbox-input" />
                                  </clr-checkbox-wrapper>
                                </clr-checkbox-container>
                              </div>
                            </div>
                          </div>
                        }
                      }
                    }
                    <br />
                    <br />
                    <br />
                    <br />
                  </form>
                }
              </div>
            </div>
          </div>
        </clr-tab-content>
      </clr-tab>

      <!-- 2. TAB: Auswahl Zählerarten -->
      <clr-tab>
        <button
          clrTabLink
          (click)="tabChange()"
          [title]="'Tabellenerstellung' | mrTranslate"
          data-test-id="fat-objekt-tab-messwerte">
          {{ 'Messwerte' | mrTranslate | titlecase }}
        </button>
        <clr-tab-content *clrIfActive>
          <div id="formularerstellungsWrapper" class="fat-scroll-container">
            <div class="clr-row">
              <div class="clr-col-3"></div>
              @if (formulare) {
                <div class="clr-col-12 clr-col-lg-6">
                  <h3 id="title">{{ 'Messarten auswählen' | mrTranslate }}:</h3>
                  <div>
                    <clr-accordion>
                      @for (tabelle of tabellenNames; track tabelle) {
                        <clr-accordion-panel (clrAccordionPanelOpenChange)="panelChange($event, tabelle)">
                          <clr-accordion-title>
                            <clr-checkbox-wrapper>
                              <input
                                type="checkbox"
                                clrCheckbox
                                [checked]="tabellenCheckboxStates[selectedVorlageName][tabelle.ID]"
                                (change)="onCheckboxChange(tabelle.ID, $event.target.checked)" />
                              <label>{{ tabelle.Bezeichnung }} | {{ getCode(tabelle.ID) }}</label>
                            </clr-checkbox-wrapper>
                          </clr-accordion-title>
                          <clr-accordion-content *clrIfExpanded>
                            @if (tabelle.HasHelper) {
                              <button
                                class="btn btn-sm"
                                (click)="openedHelperId.set(tabelle.ID); isHelperModalOpen.set(true)">
                                <cds-icon shape="help-info" />
                              </button>
                            }
                            <span>{{ tabelle.bemerkung }}</span>
                            @if (tabellensourcetype == 0) {
                              <div class="limit-height-500">
                                @if (tabellen) {
                                  <clr-datagrid style="padding-top: 0px" class="datagrid-compact">
                                    @for (column of tabellen.columns; track column) {
                                      <clr-dg-column [clrDgField]="column.id">
                                        <ng-container
                                          *clrDgHideableColumn="{
                                            hidden: column.id | hideIDColumns: ['i_sort', 'szaehnid', 'zart'],
                                          }">
                                          {{ column.id | mrTranslate | titlecase }}
                                        </ng-container>
                                      </clr-dg-column>
                                    }
                                    <clr-dg-row *clrDgItems="let row of tabellen.rows" [clrDgItem]="row">
                                      @for (cell of tabellen.columns; track cell) {
                                        <clr-dg-cell class="name-cell">
                                          {{ row[cell.id] | tablePrettyPrint }}
                                        </clr-dg-cell>
                                      }
                                    </clr-dg-row>
                                    <clr-dg-footer>
                                      {{ tabellen.rows.length }} {{ 'Zeilen' | mrTranslate }}
                                    </clr-dg-footer>
                                  </clr-datagrid>
                                }
                              </div>
                            } @else {
                              @if (tabellen) {
                                <clr-datagrid style="padding-top: 0px" class="datagrid-compact">
                                  <!-- ! deleteForTabellen not exist -->
                                  <!-- <clr-dg-column class="widthdelete" clrDgField="delete" [hidden]="locked">{{ 'Löschen' |
                                                  mrTranslate }}</clr-dg-column> -->
                                  @for (column of tabellen.columns; track column) {
                                    <clr-dg-column [clrDgField]="column.id">
                                      <ng-container
                                        *clrDgHideableColumn="{
                                          hidden:
                                            column.id
                                            | hideIDColumns: ['i_sort', 'szaehnid', 'soll', 'tol +', 'tol -', 'zart'],
                                        }">
                                        {{ column.id | mrTranslate | titlecase }}
                                      </ng-container>
                                    </clr-dg-column>
                                  }
                                  <clr-dg-row *clrDgItems="let row of tabellen.rows" [clrDgItem]="row">
                                    <!-- <clr-dg-cell class="widthdelete" [hidden]="locked">
                                                    <cds-icon shape="times" (click)="deleteForTabellen(row['ID'])"
                                                      class="cursor-pointer"/>
                                                    </clr-dg-cell> -->
                                    @for (cell of tabellen.columns; track cell) {
                                      <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                                    }
                                  </clr-dg-row>
                                  <clr-dg-footer>{{ tabellen.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                                </clr-datagrid>
                              }
                            }
                            <br />
                          </clr-accordion-content>
                        </clr-accordion-panel>
                      }
                    </clr-accordion>
                  </div>
                  <br />
                </div>
              }
            </div>
          </div>
        </clr-tab-content>
      </clr-tab>
    </clr-tabs>
  </div>
</div>

<app-hilfe-beschreibung-modal
  [(isModalOpen)]="isHelperModalOpen"
  [table]="'SZAEHN'"
  [id]="openedHelperId()"
  [readonly]="true" />

<clr-modal [(clrModalOpen)]="showmodalselectVorlage" [clrModalClosable]="false" [clrModalSize]="'sm'">
  <h3 class="modal-title">{{ 'Vorlage auswählen' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm clrLayout="vertical">
      <select clrSelect #_vorlage_new data-test-id="fat-vorlage-template-select" style="width: 220px">
        @for (val of vorlageNames; track val) {
          <option>{{ val.VorlageName }}</option>
        }
      </select>
    </form>
    <br />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="selectVorlage()">{{ 'OK' | mrTranslate }}</button>
    <!-- <button type="button" class="btn" (click)="showmodalselectVorlage = false">{{'Abbrechen' | mrTranslate}}</button> -->
  </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="isGroupVisible" [clrModalClosable]="true" [clrModalSize]="'lg'">
  <h3 class="modal-title">{{ groupModalTitle | mrTranslate }}</h3>
  <div class="modal-body" style="background-color: #fafafa; padding: 1.5rem">
    <div class="modal-description">
      {{
        'Geben Sie Firma und Ort für die neue Kundengruppe an. Beide Felder müssen mindestens 3 Zeichen enthalten.'
          | mrTranslate
      }}
    </div>

    <div
      class="modal-description"
      style="
        margin-top: 0.5rem;
        padding: 0.5rem;
        background-color: #e1f5fe;
        border-left: 3px solid #0288d1;
        border-radius: 3px;
        color: #0277bd;
      ">
      <cds-icon shape="info-circle" style="color: #0288d1; margin-right: 0.5rem; vertical-align: text-top" />
      {{
        'Die neue Gruppe wird nur in der Liste angezeigt, wenn sie Ihnen in Okta zugewiesen ist. Kontaktieren Sie Ihren
                              Administrator, um Zugriff zu erhalten.' | mrTranslate
      }}
    </div>
    <form
      clrForm
      #gruppeForm
      clrLayout="vertical"
      [formGroup]="gruppeedit"
      #f="ngForm"
      (ngSubmit)="saveIfValid()"
      class="group-creation-form"
      style="
        background-color: white;
        padding: 0rem 1.5rem 1.5rem 1.5rem;
        border-radius: 4px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      ">
      <!-- Admin-only: choose group type (internal vs customer) -->
      @if (hasAdminRights) {
        <div class="clr-row" style="margin-top: 0.25rem">
          <div class="clr-col-12">
            <clr-radio-container>
              <label class="clr-control-label" style="font-weight: 600; color: #333">
                {{ 'Gruppentyp' | mrTranslate }}
              </label>
              <clr-radio-wrapper>
                <input type="radio" clrRadio value="internal" formControlName="groupType" name="groupType" />
                <label>{{ 'Interne Gruppe' | mrTranslate }}</label>
              </clr-radio-wrapper>
              <clr-radio-wrapper>
                <input type="radio" clrRadio value="external" formControlName="groupType" name="groupType" />
                <label>{{ 'Kunden Gruppe' | mrTranslate }}</label>
              </clr-radio-wrapper>
            </clr-radio-container>
          </div>
        </div>
      }

      <div class="clr-row">
        <div class="clr-col-12">
          <clr-datalist-container>
            <label for="firma-input" class="clr-control-label" style="font-weight: 600; color: #333">
              {{ 'Firma' | mrTranslate }} *
            </label>
            <input
              id="firma-input"
              clrDatalistInput
              type="search"
              class="clr-input"
              formControlName="kname"
              name="firma"
              placeholder="{{ 'Mindestens 3 Zeichen eingeben...' | mrTranslate }}"
              style="width: 260px; min-width: 260px"
              autocomplete="off" />
            <datalist>
              @for (company of validatedCompanies; track company) {
                <option [value]="company">{{ company }}</option>
              }
            </datalist>
            <clr-control-error *clrIfError="'required'">
              {{ 'Firma ist erforderlich' | mrTranslate }}
            </clr-control-error>
            <clr-control-error *clrIfError="'minlength'">
              {{ 'Firma muss mindestens 3 Zeichen haben' | mrTranslate }}
            </clr-control-error>
          </clr-datalist-container>
        </div>
      </div>

      <div class="clr-row">
        <div class="clr-col-12">
          <clr-datalist-container>
            <label for="ort-input" class="clr-control-label" style="font-weight: 600; color: #333">
              {{ 'Ort' | mrTranslate }} *
            </label>
            <input
              id="ort-input"
              clrDatalistInput
              type="search"
              class="clr-input"
              formControlName="kort"
              name="ort"
              placeholder="{{ 'Mindestens 3 Zeichen eingeben...' | mrTranslate }}"
              style="width: 260px; min-width: 260px"
              autocomplete="off" />
            <datalist>
              @for (location of validatedLocations; track location) {
                <option [value]="location">{{ location }}</option>
              }
            </datalist>
            <clr-control-error *clrIfError="'required'">
              {{ 'Ort ist erforderlich' | mrTranslate }}
            </clr-control-error>
            <clr-control-error *clrIfError="'minlength'">
              {{ 'Ort muss mindestens 3 Zeichen haben' | mrTranslate }}
            </clr-control-error>
          </clr-datalist-container>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer" style="background-color: #f8f8f8; border-top: 1px solid #e0e0e0">
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!isGroupFormValid"
      [class.btn-disabled]="!isGroupFormValid"
      (click)="f.ngSubmit.emit()"
      style="background-color: #0079ad; border-color: #0079ad">
      {{ 'Speichern' | mrTranslate }}
    </button>
    <button
      type="button"
      class="btn btn-outline"
      (click)="cancelGroupCreation()"
      style="border-color: #666; color: #666">
      {{ 'Abbrechen' | mrTranslate }}
    </button>
  </div>
</clr-modal>
